/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { AbstractResourceService, JsonApiListResourceMetadataBase, JsonApiResource } from '@irian-ro/abstract-resource';
import { Observable } from 'rxjs';
import {
  MasterRoutingSolutionTrackingViewModel,
} from '@well/domain';
import {
  ShipmentGroupSolutionDtoModel, ShipmentGroupSolutionSegmentDtoModel
} from '@well/delivery-libs/shipment/domain';

@Injectable({
  providedIn: 'root'
})
export class ShipmentGroupSolutionResourceService extends AbstractResourceService<any, ShipmentGroupSolutionDtoModel, any, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('shipmentGroupSolutionUrl'),
      undefined,
      ShipmentGroupSolutionDtoModel
    );
  }

  cloneSolutionWithUpdatedSegment(shipmentGroupSolutionUuid: string, segment: ShipmentGroupSolutionSegmentDtoModel){
    return <Observable<JsonApiResource<any, any>>>this.httpClient?.post(`${this.url}/clone/${shipmentGroupSolutionUuid}/update/segment`, segment);
  }

  getShipmentGroupSolutionSummariesForSpOrderPreferred(spOrderUuid: string): Observable<JsonApiResource<MasterRoutingSolutionTrackingViewModel, JsonApiListResourceMetadataBase>> {
    return <Observable<JsonApiResource<MasterRoutingSolutionTrackingViewModel, JsonApiListResourceMetadataBase>>>this.httpClient?.get(`${this.url}/summary/sp-order-preferred/${spOrderUuid}`);
  }
}
